import { render, staticRenderFns } from "./TNC10000.vue?vue&type=template&id=0de46e8f&"
import script from "./TNC10000.vue?vue&type=script&lang=js&"
export * from "./TNC10000.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports